export interface Category {
  slug: string;
  name: string;
  en: string;
  desc: string;
  tagline: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: "chuanyue",
    name: "穿越",
    en: "穿越",
    desc: "穿越到木叶，从零开始改变命运，与鸣人佐助并肩作战的传奇篇章。",
    tagline: "开局就穿越，命运自己改写",
    icon: "ri-earth-line",
  },
  {
    slug: "xitong",
    name: "系统",
    en: "系统",
    desc: "绑定专属系统，签到打卡、任务奖励、金手指加身，实力突飞猛进。",
    tagline: "系统在手，忍界横着走",
    icon: "ri-cpu-line",
  },
  {
    slug: "zhongsheng",
    name: "重生",
    en: "重生",
    desc: "重活一世，预知剧情走向，弥补所有遗憾，守护想守护的人。",
    tagline: "带着记忆重来，悔恨不再重演",
    icon: "ri-refresh-line",
  },
  {
    slug: "richang",
    name: "日常",
    en: "日常",
    desc: "忍村里的温馨日常，校园、食堂、任务间隙的轻松小故事。",
    tagline: "打打杀杀之外，也有烟火人间",
    icon: "ri-sun-line",
  },
  {
    slug: "zhandou",
    name: "战斗",
    en: "战斗",
    desc: "热血澎湃的忍术对决，巅峰战力碰撞，改写终局之战的全新可能。",
    tagline: "每一场战斗，都是逆袭的开始",
    icon: "ri-sword-line",
  },
];

export const getCategory = (slug: string): Category | undefined =>
  categories.find((c) => c.slug === slug);